import { LinkButton, theme, useToast } from '@arnold/common';
import styled from '@emotion/styled/macro';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSendMagicLinkMutation } from '../../generated/hooks';

const TextWrap = styled.div`
  margin-bottom: ${theme.spacing.h};
  text-align: center;
`;

interface IProps {
  email: string;
}

const RecoverPasswordSuccess = ({ email }: IProps) => {
  const [t] = useTranslation('loginForm');
  const { addToast } = useToast();
  const [counter, setCounter] = useState(10);
  const [sendMagicLink] = useSendMagicLinkMutation();

  const startCountdown = (seconds: number) => {
    let index = seconds;

    const interval = setInterval(() => {
      index--;
      setCounter(index - 1);
      if (index === 0) {
        clearInterval(interval);
        setCounter(0);
      }
    }, 1000);
  };
  useEffect(() => {
    startCountdown(11);
  }, []);

  return (
    <>
      <TextWrap>
        <Trans i18nKey="loginForm:magicLinkText" values={{ email, time: counter }} />
      </TextWrap>
      <div className="text-center">
        <LinkButton
          disabled={counter > 0}
          data-cy={'admin-send-again-button'}
          onClick={async () => {
            try {
              await sendMagicLink({ variables: { username: email } });
            } catch (e) {
              addToast(t('sendingLinkFailed'));
            }
            startCountdown(10);
            addToast(t('loginForm:modalTitle'));
          }}
        >
          {t('recoverPassword:sendAgain')}
        </LinkButton>
      </div>
    </>
  );
};

export default RecoverPasswordSuccess;
